jQuery(document).ready(function () {

  //añadir visible al hacer click en selector-idiomas-cabecera
  jQuery(".selector-idiomas-cabecera").click(function() {
    jQuery(".selector-idiomas-cabecera__contenedor").addClass("visible");
  });

  //quitar visible al hacer click fuera de selector-idiomas-cabecera
  jQuery(document).mouseup(function (e) {
    var container = jQuery(".selector-idiomas-cabecera__contenedor");
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      container.removeClass("visible");
    }
  });


  // Para cabecera fixed y admin bar
  var header = jQuery(".navbar");
  var experiencia_migas_enlaces = jQuery(".experiencia-migas-enlaces");
  var scrollChange = 1;
  jQuery(window).scroll(function () {
    var scroll = jQuery(window).scrollTop();

    if (scroll >= scrollChange) {
      header.addClass("fix-espacio-cabecera");
      jQuery("body").addClass("scroll-activo");
      experiencia_migas_enlaces.addClass("fix-experiencia-migas-enlaces");
    } else {
      header.removeClass("fix-espacio-cabecera");
      jQuery("body").removeClass("scroll-activo");
      experiencia_migas_enlaces.removeClass("fix-experiencia-migas-enlaces");
    }
  });

  // Swiper JS
  var swiper_columnas = new Swiper(".swiper_columnas-imagen-texto", {
    // slidesPerView: "auto",

    // Responsive breakpoints
    breakpoints: {
      // when window width is >= 320px
      0: {
        slidesPerView: "auto",
        spaceBetween: 30,
        slidesOffsetBefore: 30,
      },

      320: {
        slidesPerView: "auto",
        spaceBetween: 30,
        slidesOffsetBefore: 30,
      },
      // when window width is >= 480px
      768: {
        slidesPerView: "auto",
        spaceBetween: 30,
        slidesOffsetBefore: 30,
      },
      // when window width is >= 640px
      920: {
        slidesPerView: "auto",
        spaceBetween: 0,
      },
    },
    // Optional parameters
    direction: "horizontal",
    loop: false,

    // If we need pagination
    // pagination: {
    //     el: ".swiper-pagination",
    // },

    // Navigation arrows
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },

    // And if we need scrollbar
    // scrollbar: {
    //     el: ".swiper-scrollbar",
    // },
  });

  var swiper_opiniones = new Swiper(".swiper_opiniones", {
    spaceBetween: 40,
    slidesPerView: "auto",
    slidesOffsetBefore: 20,
    slidesOffsetAfter: 10,
    // Responsive breakpoints
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1.1,
      },
      // when window width is >= 480px
      620: {
        slidesPerView: 2.1,
      },
      750: {
        slidesPerView: 3.1,
      },
      // when window width is >= 640px
      920: {
        slidesPerView: "auto",
      },
    },
    // Optional parameters
    direction: "horizontal",
    loop: false,

    // If we need pagination
    pagination: {
      el: ".swiper-pagination",
    },

    // Navigation arrows
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },

    // And if we need scrollbar
    // scrollbar: {
    //     el: ".swiper-scrollbar",
    // },
  });

  var swiper_experiencias = new Swiper(".swiper_experiencias", {
    spaceBetween: 40,
    slidesPerView: "auto",

    breakpoints: {
      320: {
        slidesOffsetBefore: 0,
        visibilityFullFit: true,
        autoResize: false,
      },
      620: {
        slidesOffsetBefore: 0,
        visibilityFullFit: true,
        autoResize: false,
      },
      750: {
        slidesOffsetBefore: 50,
        visibilityFullFit: true,
        autoResize: false,
      },
      1100: {
        slidesOffsetBefore: 50,
        visibilityFullFit: true,
        autoResize: false,
      },
      1400: {
        slidesOffsetBefore: 50,
        visibilityFullFit: true,
        autoResize: false,
      },
    },
    // Optional parameters
    direction: "horizontal",
    loop: false,

    // If we need pagination
    // pagination: {
    //      el: ".swiper-pagination",
    // },

    // Navigation arrows
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },

    // And if we need scrollbar
    // scrollbar: {
    //     el: ".swiper-scrollbar",
    // },
  });

  var swiper_entradas_relacionadas = new Swiper(
    ".swiper_entradas_relacionadas",
    {
      spaceBetween: 40,
      slidesPerView: "auto",

      breakpoints: {
        320: {
          slidesOffsetBefore: 0,
          visibilityFullFit: true,
          autoResize: false,
        },
        620: {
          slidesOffsetBefore: 0,
          visibilityFullFit: true,
          autoResize: false,
        },
        750: {
          slidesOffsetBefore: 50,
          visibilityFullFit: true,
          autoResize: false,
        },
        1100: {
          slidesOffsetBefore: 50,
          visibilityFullFit: true,
          autoResize: false,
        },
        1400: {
          slidesOffsetBefore: 50,
          visibilityFullFit: true,
          autoResize: false,
        },
      },
      // Optional parameters
      direction: "horizontal",
      loop: false,

      // If we need pagination
      // pagination: {
      //      el: ".swiper-pagination",
      // },

      // Navigation arrows
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },

      // And if we need scrollbar
      // scrollbar: {
      //     el: ".swiper-scrollbar",
      // },
    }
  );

  var swiper_entradas_relacionadas_not_found = new Swiper(
    ".swiper_entradas_relacionadas_not_found",
    {
      spaceBetween: 40,
      slidesPerView: "auto",

      breakpoints: {
        320: {
          slidesOffsetBefore: 0,
          visibilityFullFit: true,
          autoResize: false,
        },
        620: {
          slidesOffsetBefore: 0,
          visibilityFullFit: true,
          autoResize: false,
        },
        750: {
          slidesOffsetBefore: 50,
          visibilityFullFit: true,
          autoResize: false,
        },
        1100: {
          slidesOffsetBefore: 50,
          visibilityFullFit: true,
          autoResize: false,
        },
        1400: {
          slidesOffsetBefore: 50,
          visibilityFullFit: true,
          autoResize: false,
        },
      },
      // Optional parameters
      direction: "horizontal",
      loop: false,

      // If we need pagination
      // pagination: {
      //      el: ".swiper-pagination",
      // },

      // Navigation arrows
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },

      // And if we need scrollbar
      // scrollbar: {
      //     el: ".swiper-scrollbar",
      // },
    }
  );

  var swiper_experiencia_beneficios_extendido = new Swiper(
    ".swiper_experiencia-beneficios-extendido",
    {
      breakpoints: {
        0: {
          slidesOffsetBefore: 0,
        },
        320: {
          slidesPerView: 1,
          spaceBetween: 10,
          slidesOffsetBefore: 0,
        },
        620: {
          slidesPerView: 2,
          spaceBetween: 10,
          slidesOffsetBefore: 0,
        },
        750: {
          slidesPerView: 2,
          spaceBetween: 10,
          slidesOffsetBefore: 0,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 50,
          slidesOffsetBefore: 70,
        },
      },
      // Optional parameters
      direction: "horizontal",
      loop: false,

      // If we need pagination
      // pagination: {
      //     el: ".swiper-pagination",
      // },

      // Navigation arrows
      navigation: false,

      // And if we need scrollbar
      // scrollbar: {
      //     el: ".swiper-scrollbar",
      // },
    }
  );

  var swiper_experiencias_relacionadas = new Swiper(
    ".swiper_experiencias-relacionadas",
    {
      spaceBetween: 40,
      slidesPerView: "auto",

      breakpoints: {
        320: {
          slidesOffsetBefore: 0,
          visibilityFullFit: true,
          autoResize: false,
        },
        620: {
          slidesOffsetBefore: 0,
          visibilityFullFit: true,
          autoResize: false,
        },
        750: {
          slidesOffsetBefore: 50,
          visibilityFullFit: true,
          autoResize: false,
        },
        1100: {
          slidesOffsetBefore: 50,
          visibilityFullFit: true,
          autoResize: false,
        },
        1400: {
          slidesOffsetBefore: 50,
          visibilityFullFit: true,
          autoResize: false,
        },
      },
      // Optional parameters
      direction: "horizontal",
      loop: false,

      // If we need pagination
      // pagination: {
      //      el: ".swiper-pagination",
      // },

      // Navigation arrows
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },

      // And if we need scrollbar
      // scrollbar: {
      //     el: ".swiper-scrollbar",
      // },
    }
  );
  var swiper_entradas_relacionadas_listado = new Swiper(
    ".swiper_entradas_relacionadas_listado",
    {
      spaceBetween: 40,
      slidesPerView: "auto",

      breakpoints: {
        320: {
          slidesOffsetBefore: 0,
          visibilityFullFit: true,
          autoResize: false,
        },
        620: {
          slidesOffsetBefore: 0,
          visibilityFullFit: true,
          autoResize: false,
        },
        750: {
          slidesOffsetBefore: 0,
          visibilityFullFit: true,
          autoResize: false,
        },
        1100: {
          slidesOffsetBefore: 0,
          visibilityFullFit: true,
          autoResize: false,
        },
        1400: {
          slidesOffsetBefore: 0,
          visibilityFullFit: true,
          autoResize: false,
        },
      },
      // Optional parameters
      direction: "horizontal",
      loop: false,

      // If we need pagination
      // pagination: {
      //      el: ".swiper-pagination",
      // },

      // Navigation arrows
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },

      // And if we need scrollbar
      // scrollbar: {
      //     el: ".swiper-scrollbar",
      // },
    }
  );
  var swiper_entradas_relacionadas_listado_not_found = new Swiper(
    ".swiper_entradas_relacionadas_listado_not_found",
    {
      spaceBetween: 40,
      slidesPerView: "auto",

      breakpoints: {
        320: {
          slidesOffsetBefore: 0,
          visibilityFullFit: true,
          autoResize: false,
        },
        620: {
          slidesOffsetBefore: 0,
          visibilityFullFit: true,
          autoResize: false,
        },
        750: {
          slidesOffsetBefore: 0,
          visibilityFullFit: true,
          autoResize: false,
        },
        1100: {
          slidesOffsetBefore: 0,
          visibilityFullFit: true,
          autoResize: false,
        },
        1400: {
          slidesOffsetBefore: 0,
          visibilityFullFit: true,
          autoResize: false,
        },
      },
      // Optional parameters
      direction: "horizontal",
      loop: false,

      // If we need pagination
      // pagination: {
      //      el: ".swiper-pagination",
      // },

      // Navigation arrows
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },

      // And if we need scrollbar
      // scrollbar: {
      //     el: ".swiper-scrollbar",
      // },
    }
  );

  var swiper_prensa = new Swiper(".swiper_prensa", {
    spaceBetween: 40,
    // slidesPerView: "auto",
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    
    // Optional parameters
    direction: "horizontal",
    loop: false,

    // If we need pagination
    pagination: {
      el: ".swiper-pagination",
    },

    // Navigation arrows
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },

    // Responsive breakpoints
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1,
      },
      // when window width is >= 680px
      620: {
        slidesPerView: 1,
      },
      750: {
        slidesPerView: 2,
      },
      // when window width is >= 940px
      920: {
        slidesPerView: 3,
      },
    },
  });

  // Buscador Blog
  var iconoBuscador = document.querySelector(".buscador-blog__icono");
  var buscador = document.querySelector(".blog__buscador");
  var cerrarBuscador = document.querySelector(".cerrar-buscador-blog");

  if (iconoBuscador && buscador && cerrarBuscador) {
    iconoBuscador.addEventListener("click", function () {
      iconoBuscador.classList.toggle("ocultar");
      cerrarBuscador.classList.toggle("mostrar");
      buscador.classList.toggle("mostrar");
    });

    cerrarBuscador.addEventListener("click", function () {
      iconoBuscador.classList.toggle("ocultar");
      cerrarBuscador.classList.toggle("mostrar");
      buscador.classList.toggle("mostrar");
    });
  }
});

// Función leer más y leer menos para cards opiniones
(function ($) {
  $(document).ready(function () {
    $(".wonder-readmore").click(function () {
      $(this).hide();
      var parentPanel = $(this).closest(".wonderplugintabs-panel");
      var swiperSlideParent = $(this).closest(".opinion.swiper-slide");

      parentPanel.find(".wonder-readless").show();
      parentPanel.find(".wonder-readmore-content").show();
      swiperSlideParent.addClass("overflow_activo");
    });

    $(".wonder-readless").click(function () {
      $(this).hide();
      var parentPanel = $(this).closest(".wonderplugintabs-panel");
      parentPanel.find(".wonder-readmore").show();
      parentPanel.find(".wonder-readmore-content").hide();
    });

    // convertir barra scroll en btns en home
    document.getElementById('scroll-left').addEventListener('click', function() {
      document.getElementById('texto-con-cinco-imagenes-block-contenedor').scrollBy({
        left: -100,
        behavior: 'smooth'
      });
    });
    
    document.getElementById('scroll-right').addEventListener('click', function() {
      document.getElementById('texto-con-cinco-imagenes-block-contenedor').scrollBy({
        left: 100,
        behavior: 'smooth'
      });
    });

    const scrollContent = document.getElementById('texto-con-cinco-imagenes-block-contenedor');
    const scrollLeftBtn = document.getElementById('scroll-left');
    const scrollRightBtn = document.getElementById('scroll-right');

    // Función para actualizar el estado de los botones
    function updateButtons() {
      const maxScrollLeft = scrollContent.scrollWidth - scrollContent.clientWidth;

      // Deshabilitar los botones según la posición de desplazamiento
      scrollLeftBtn.disabled = scrollContent.scrollLeft === 0;
      scrollRightBtn.disabled = scrollContent.scrollLeft >= maxScrollLeft;
    }

    // Eventos de clic para las flechas de desplazamiento
    scrollLeftBtn.addEventListener('click', function() {
      scrollContent.scrollBy({ left: -100, behavior: 'smooth' });
      setTimeout(updateButtons, 300); // Asegurar que los botones se actualicen después del scroll
    });

    scrollRightBtn.addEventListener('click', function() {
      scrollContent.scrollBy({ left: 100, behavior: 'smooth' });
      setTimeout(updateButtons, 300); // Asegurar que los botones se actualicen después del scroll
    });

    // Detectar el desplazamiento mediante arrastre del ratón
    scrollContent.addEventListener('scroll', updateButtons);

    // Inicializar el estado de los botones
    updateButtons();
  });
})(jQuery);


